// extracted by mini-css-extract-plugin
module.exports = {"categories__wrapper":"bl_fH","categories__list":"bl_fJ"};